import { render, staticRenderFns } from "./PreviewEdit.vue?vue&type=template&id=70462dbc&scoped=true&"
import script from "./PreviewEdit.vue?vue&type=script&lang=js&"
export * from "./PreviewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70462dbc",
  null
  
)

export default component.exports